import * as React from 'react';
import { SelectFields } from '../../selectFields/SelectFields';
import styled from 'styled-components/macro';
import { ActionButtonProps, Field } from './types';
import { NewModal } from '../NewModal';

type Props = {
  onClose: () => void;
  allFields: Field[];
  initialFields: Field[];
  title: string;
  onBackClick?: () => void;
  maxFieldConfig?: {
    count: number;
    hideText?: boolean;
  };
  actionButtons?: ActionButtonProps[];
};

const Body = styled.div`
  display: flex;
  box-sizing: border-box;
`;
export const TABLE_NAME_PREFIX = 'CovideoTableFields';
export const ModalCustomTableFields = ({
  onClose,
  allFields,
  initialFields,
  title,
  maxFieldConfig = { count: 100, hideText: true },
  actionButtons,
}: Props) => {
  return (
    <NewModal
      headerText={title}
      hideHeader={false}
      closeModalOnBackdropOrEscPress={true}
      closeModal={onClose}
      headerMargin='0 0 32px 0'
      style={{
        content: {
          minWidth: '1064px',
          maxWidth: '1064px',
          padding: '24px 24px 16px 24px',
          paddingLeft: '32px',
          minHeight: 555,
        },
      }}
    >
      <Body>
        <SelectFields
          allFields={allFields}
          initialFields={initialFields}
          scrollableHeight='338px'
          maxFieldConfig={maxFieldConfig}
          actionButtons={actionButtons}
          isForCustomizeTable={true}
        />
      </Body>
    </NewModal>
  );
};
